import React, { Component } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { HistoryLayout } from '../../../../common/history/history-layout.component';
import { TablePagination } from '../../../../common/details-table/table-pagination.component';
import { contractHistoryActions } from "../../../../../store/external/finance/contract/contract-details-history.reducer";
import { Loading } from '../../../../common/loading';
import { MODAL_CUSTOM_MESSAGE } from "../../../../../constants/external-constants";

class ContractHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            enableSearchBox: false,
            isLoading: true,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
        }
    }
    componentDidMount() {
        const { getContractHistoryLogs, contractId } = this.props;

        getContractHistoryLogs(contractId)
            .then(() => {
                this.setState({ isLoading: false })
            });
    }

    componentWillUnmount() {
        this.props.resetContractHistory();
    }

    getTableData(pageIndex) {
        this.props.getContractHistoryLogs(this.props.contractId, pageIndex);
    }

    resizePage = (pageSize) => {
        const { resizeContractHistoryLogs, getContractHistoryLogs, contractId } = this.props;
        resizeContractHistoryLogs(pageSize)
        this.setState({ isLoading: true });

        getContractHistoryLogs(contractId)
            .then(() => {
                this.setState({ isLoading: false })
            });
    }

    contractPaginationAction = (pageIndex) => {
        const { getContractHistoryLogs, contractId } = this.props;
        getContractHistoryLogs(contractId, pageIndex);
    }

    onColumnSearch = () => {
        const { getContractHistoryLogs, contractId } = this.props;
        getContractHistoryLogs(contractId, 0);
    }

    displaySearchBox = (value) => {
        this.setState({ enableSearchBox: value })
    }
    onClickExtract = () => {
        const { contractId, extractContractHistoryLogs } = this.props;
        if (window.confirm(this.state.exportAlertMsg)) {
            extractContractHistoryLogs(contractId);
        }
    }

   
    render() {
        const { setContractHistoryColSearchStr, isReadOnly, isReadAndExtractOnly, isReadAndWrite } = this.props;
        const { Headers, Data, Pagination } = this.props.contractHistory.HistoryTable;
        return (
            <div>
            <HistoryLayout
             displaySearchBox={this.displaySearchBox}
             extractAction={this.onClickExtract}

            //Access Type
            isReadOnly={isReadOnly}
            isReadAndExtractOnly={isReadAndExtractOnly}
            isReadAndWrite={isReadAndWrite} 
            hideCustomColumn={true}
            >
                <TablePagination
                    key="table-pagination-key"
                    columns={Headers}
                    pageList={Data}
                    pages={Pagination}
                    paginationAction={this.contractPaginationAction}
                    onColumnSearch={() => { this.onColumnSearch() }}
                    onColumnSearchChange={setContractHistoryColSearchStr}
                    isColSearchShow={this.state.enableSearchBox}
                    resizePage={this.resizePage}
                    totalPage={Pagination.TotalEntries}
                    isNotSortable={true}
                    isLoading={this.state.isLoading}
                />
            </HistoryLayout>
        </div>
        );
    }
}

export default connect(
    state => {
        const { contractHistory } = state;

        return {
            contractHistory
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, contractHistoryActions),
        dispatch
    )
)(ContractHistory);